<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Fechamento de período</span>
      </v-row>

      <!-- LISTAGEM -->
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-card outlined class="borda" flat width="100%">
            <v-data-table
              no-data-text="Nenhum fechamento cadastrado"
              hide-default-footer
              :items="fechamentos"
              :headers="cabecalho"
              :items-per-page="items_per_pag"
              class="elevation-0"
              :loading="loading"
            >
              <template v-slot:item.data="{ item }">
                <span>{{ item.fechamento_data | moment('LL') }}</span>
              </template>
              <template v-slot:item.acao="{ item }">
                <v-tooltip top color="black" v-if="!editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" text>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Sem autorização para
                    <span class="orange--text">editar</span> ou
                    <span class="red--text">excluir</span>
                  </span>
                </v-tooltip>
                <v-tooltip top color="black" v-if="editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="menu('Editar',item)" icon v-bind="attrs" v-on="on" text>
                      <v-icon>mdi-lock-open</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Alterar de
                    data de fechamento
                  </span>
                </v-tooltip>
              </template>

              <template v-slot:footer>
                <v-row justify="center" class="mb-2">
                  <v-btn
                    v-if="items_per_pag > 10"
                    @click="items_per_pag -= 10"
                    text
                    color="#1F36C7"
                  >Mostrar menos</v-btn>
                  <v-btn
                    v-if="10 > items_per_pag"
                    @click="carregarMais()"
                    text
                    color="#1F36C7"
                  >Carregar mais</v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="historico.length > 0">
        <v-col cols="12" sm="12" md="12">
          <v-card class="borda" flat>
            <v-card-title>
              <span class="headline ma-3">Histórico de alteração</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-data-table
                no-data-text="Nenhum fechamento cadastrado"
                :items="historico"
                :headers="cabecalhoHistorico"
                :items-per-page="items_per_pag2"
                class="elevation-0"
                :loading="loading"
                hide-default-footer
                @page-count="pageCount = $event"
                :page.sync="page"
              >
                <template v-slot:item.fechamento="{ item }">
                  <span>{{ item.fechamento.fechamento_data | moment('LL') }}</span>
                </template>
                <template v-slot:item.historico_motivo="{ item }">
                  <span
                    style="text-align: justify; text-justify: inter-word;"
                  >{{item.historico_motivo}}</span>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <span>{{ item.created_at | moment('LLL') }}</span>
                </template>
                <template v-slot:footer>
                  <v-pagination color="#283480" v-model="page" :length="pageCount"></v-pagination>
                </template>

                <template v-slot:item.usuario="{ item }">
                  <v-avatar size="32" v-if="imgAWS(item.usuario)">
                    <img :src="getHash(item.usuario)" :lazy-src="getHash(item.usuario)" />
                  </v-avatar>
                  <v-avatar size="32" color="#283480" v-if="!item.usuario.usuario_imagem">
                    <span
                      class="white--text headline text-uppercase"
                    >{{item.usuario.usuario_nome.charAt(0)}}</span>
                  </v-avatar>
                  <v-avatar size="32" v-else-if="!imgAWS(item.usuario)">
                    <img :src="item.usuario.usuario_imagem" :lazy-src="item.usuario.usuario_imagem" />
                  </v-avatar>
                  <span class="ml-1">{{ item.usuario.usuario_nome }}</span>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- EDITAR FECHAMENTO -->
      <v-dialog v-model="dialog_fechamento" persistent width="500px">
        <v-form ref="form2" v-model="valid" @submit.prevent="save()">
          <v-card flat class="borda">
            <v-card-title class="ma-2">
              <span>Editar Fechamento</span>
              <v-spacer></v-spacer>
              <v-btn icon text @click="close()">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col class="mb-n5" cols="12" sm="12" md="12">
                  <span class="font-weight-bold black--text">Data de fechamento *</span>
                  <v-menu
                    ref="menuFechamento"
                    v-model="menuFechamento"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    calculate-widths
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        solo
                        flat
                        outlined
                        dense
                        @blur="novo_fechamento.fechamento_data = parseDate(dateFormattedFechamento)"
                        v-model="dateFormattedFechamento"
                        append-icon="mdi-calendar"
                        v-mask="data_mask"
                        :rules="requiredRules"
                        v-on="on"
                        @input="menu1 = false"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFechamento"
                      no-title
                      locale="pt-br"
                      scrollable
                      @input="menuFechamento = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span class="font-weight-bold black--text">Motivo de alteração *</span>
                  <v-textarea
                    v-model="novo_fechamento.historico_motivo"
                    auto-grow
                    dense
                    solo
                    :rules="requiredRules"
                    rows="1"
                    outlined
                    flat
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row class="mb-4" no-gutters justify="center">
                <v-btn
                  class="mr-2"
                  @click="close()"
                  rounded
                  style="color: #283480 !important"
                  outlined
                >Cancelar</v-btn>
                <v-btn
                  class="ml-2"
                  rounded
                  style="background-color: #283480  !important; color:#00FFD4  !important"
                  @click="save()"
                >
                  <v-icon>mdi-content-save</v-icon>
                  <span>Salvar</span>
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => {
    return {
      page: 1,
      pageCount: 0,
      data_mask: "##/##/####",
      loading: false,
      opcoes: [
        { nome: "⠀Editar", icon: "mdi-pencil-outline" },
        { nome: "⠀Excluir", icon: "mdi-delete-outline" }
      ],
      fechamentos: [],
      menuFechamento: false,
      dialog_fechamento: false,
      novo_fechamento: {
        fechamento_data: "",
        fk_id_usuario: ""
      },
      dialog_historico: false,
      dateFechamento: "",
      dateFormattedFechamento: "",
      valid: true,
      requiredRules: [v => !!v || "Campo Obrigatório."],
      items_per_pag: 10,
      items_per_pag2: 10,
      cabecalho: [
        {
          text: "Data de fechamento",
          align: "start",
          value: "data"
        },
        { text: "Ações", align: "end", sortable: false, value: "acao" }
      ],
      cabecalhoHistorico: [
        {
          text: "Quem alterou",
          align: "start",
          sortable: false,
          value: "usuario"
        },
        {
          text: "Motivo",
          width: "50%",
          align: "center",
          sortable: false,
          value: "historico_motivo"
        },
        {
          text: "Quando",
          align: "center",
          sortable: false,
          value: "created_at"
        }
      ],
      editModulo: false,
      historico: []
    };
  },
  created() {
    this.getFechamento();
    this.validaEdicaoModulo();
  },
  watch: {
    dateFechamento() {
      this.dateFormattedFechamento = this.formatDate(this.dateFechamento);
      this.novo_fechamento.fechamento_data = this.parseDate(
        this.dateFormattedFechamento
      );
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.novo_fechamento.fechamento_data);
    }
  },
  methods: {
    getHash(item) {
      let url =
        Api.getApUrl() +
        "/usuarios/imagem/show?img=" +
        item.usuario_imagem_hash;
      return url;
    },
    imgAWS(item) {
      if (item.usuario_imagem) {
        if (item.usuario_imagem.indexOf("amazonaws.com/") != -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    menu(opcao, item) {
      if (opcao === "historico") {
        this.getHistorico(item);
        this.dialog_historico = true;
      } else if (opcao === "Editar") {
        this.dateFechamento = item.fechamento_data;
        this.novo_fechamento = {
          fechamento_data: item.fechamento_data,
          historico_motivo: "",
          id_fechamento: item.id_fechamento
        };
        this.dialog_fechamento = true;
      }
    },
    getFechamento() {
      Api.get("/fechamento")
        .then(response => {
          if (response) {
            this.fechamentos = response.data.data;
            this.getHistorico(this.fechamentos);
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    getHistorico(item) {
      Api.get("/fechamento/historico?id=" + item[0].id_fechamento)
        .then(response => {
          if (response) {
            this.historico = response.data.data;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$toast.error("Oops! Ocorreu um erro.");
          throw err;
        });
    },
    save() {
      if (this.$refs.form2.validate()) {
        this.loading = true;

        Api.post(
          "/fechamento/" + this.novo_fechamento.id_fechamento,
          this.novo_fechamento
        )
          .then(response => {
            if (response) {
              this.loading = false;
              this.$toast.success("Editado com sucesso!");
              this.$refs.form2.resetValidation();
              this.close();
              this.getFechamento();
            }
          })
          .catch(err => {
            this.loading = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },

    carregarMais() {
      if (this.formData.length > this.items_per_pag) {
        this.items_per_pag += 10;
      }
    },
    carregarMais2() {
      if (this.historico.length > this.items_per_pag2) {
        this.items_per_pag2 += 10;
      }
    },
    close() {
      this.dateFormattedFechamento = "";
      this.dateFechamento = "";
      this.novo_fechamento = {
        fechamento_data: "",
        fk_id_usuario: ""
      };
      if (this.$refs.form2) {
        this.$refs.form2.resetValidation();
      }
      this.dialog_fechamento = false;
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    }
  }
};
</script>
<style lang="scss">
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>